import React from "react";
import "./Steps.css";

export default function Steps() {
  return (
    <section className="steps">
      <h2>How to Get Started</h2>
      <ol className="steps__list">
        <li>Book a strategy meeting - add your website into the bot and click the Book Meeting button</li>
        <li>Strategy meeting to discuss costs and custom chatbot requirements</li>
        <li>DarkNode builds your bespoke chatbot</li>
        <li>Client testing & feedback loop</li>
        <li>Deploy the chatbot on your website</li>
      </ol>
    </section>
  );
}
